/* eslint-disable class-methods-use-this, no-undef, no-unused-vars */
class ScrollToTop {
	constructor() {
		this.btnUpScroll = document.getElementById('btn-up-scroll');
		if (this.btnUpScroll) {
			this.init();
		}
	}

	init() {
		window.addEventListener('scroll', () => this.scrollFunction());
		this.btnUpScroll.addEventListener('click', () => this.scrollToTop());
	}

	scrollFunction() {
		if (document.body.scrollTop > 320 || document.documentElement.scrollTop > 320) {
			this.btnUpScroll.style.opacity = "1";
			this.btnUpScroll.style.transition = "all ease 0.3s";
		} else {
			this.btnUpScroll.style.opacity = "0";
		}
	}

	scrollToTop() {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	}

	// Método opcional para desplazarse a una sección específica en lugar del top de la página
	scrollToSection(sectionSelector) {
		const targetSection = document.querySelector(sectionSelector);
		if (targetSection) {
			targetSection.scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			});
		}
	}
}

export default ScrollToTop;
